/**
 * React views of the layout state (design `docs/design/mobile-layout.md` §4.2).
 * `useLayoutMode()` — the arrangement drawing now; `useLayoutPrefs()` — the Orientation +
 * Mobile-controls settings. `useMobileControlsEnabled()` is the one-line hook the touch
 * controls overlay (T3) gates on: render the stick + touch bar only when it is true.
 */

import { useSyncExternalStore } from 'react';

import { getLayoutMode, subscribeLayoutMode } from './layoutController.js';
import type { LayoutMode } from './layoutMode.js';
import { getLayoutPrefs, subscribeLayoutPrefs } from './layoutPrefs.js';
import type { LayoutPrefs } from './layoutPrefs.js';

export function useLayoutMode(): LayoutMode {
  return useSyncExternalStore(subscribeLayoutMode, getLayoutMode, getLayoutMode);
}

export function useLayoutPrefs(): LayoutPrefs {
  return useSyncExternalStore(subscribeLayoutPrefs, getLayoutPrefs, getLayoutPrefs);
}

/** T3's gate: the player has switched the on-screen controls ON (default OFF). */
export function useMobileControlsEnabled(): boolean {
  return useLayoutPrefs().mobileControls;
}
